import React from "react";
import "./SurveyLocations.scss";
import { GeoChartData, GeoChart } from "../GeoChart/GeoChart";
import { InfoItemData, InfoGroup, LitterDensityItemUIData } from "../InfoGroup/InfoGroup";

type SurveyLocationsProps = {
  geoData: GeoChartData[];
  infoGroup: InfoItemData[];
  litterDensityData?: LitterDensityItemUIData;
  isComparison?: boolean;
};

export const SurveyLocations: React.FC<SurveyLocationsProps> = ({
  geoData,
  infoGroup,
  isComparison,
  litterDensityData
}) => {
  return (
    <section className={isComparison ? 'survey_locations_section__comparison' : 'survey_locations_section'}>
        <GeoChart locationList={geoData} />
        <InfoGroup itemData={infoGroup} stackedUI={true} litterDensityInfo={litterDensityData} />
    </section>
  );
};
